<template>
  <div
    class="Line1Charts"
    @mousedown="!isEditMode && isOpenLink && echartClick($event)"
    :class="[{ link: isOpenLink && !isEditMode }, getStyle('title')]"
  >
    <DateDropDownSelect
      v-if="value.isShowRightDropDownBox"
      :selectData="selectData"
      :selectApi="selectApi"
      @selectChange="selectChange"
    >
    </DateDropDownSelect>
    <div class="echarts" :id="Configuration.id"></div>
    <div class="no-data" v-if="noData">
      <sapn>暂无数据!</sapn>
    </div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { mapState } from 'vuex';
import { jumpSomePlaceByLink, getFilterValue } from '../../../../utils/tool';
import DateDropDownSelect from '@/components/common/DateDropDownSelect/DateDropDownSelect.vue';
import { request } from '../../../../common/request';
export default {
  name: 'Line1Charts',
  components: { DateDropDownSelect },
  props: {
    ProjectInfo: Object,
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
      value: {
        isShowRightDropDownBox: false,
      },
      echartsClickData: '',
      echartsClick: '', // 静态下拉选中值
      selectData: [], // 下拉选择的时间数据
      params: {}, // 请求参数
      paramsCopy: {},
      selectApi: '',
      noData: false, // 无数据
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  // created() {
  //   clearInterval(this.apiIntervalTaskID);
  //   clearInterval(this.staticIntervalTaskID);
  //   this.registerDebounceAndThrottle();
  // },
  mounted() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();

    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    // this.getApiDataResByFilterAndResponseQuery();
    this.LocalChartDataProcessing();
    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    // 判断 数据 为本地或动态
    this.selectApi = ChartsData;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    console.log(this.params, 'aaaaaaaaa');
    this.paramsCopy = eval('(' + params + ')');
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {
    ...mapState({ isEditMode: state => state.isEditMode }),
    isOpenLink() {
      return this.Configuration.propertyData?.chartLink?.value?.isOpenLink;
    },
  },
  methods: {
    // 图表 刷新 静态数据
    handleChange(val) {
      console.log(val, 'valvalval');
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: 'ChartsData',
        value: val,
      });
    },
    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        case 'V12Style':
          style = {};
          if (bool) style['V12StyleTitle'] = true;
          style['V12Style'] = true;
          break;
        case 'V13Style':
          style = {};
          if (bool) style['V13StyleTitle'] = true;
          style['V13Style'] = true;
          break;
        case 'V14Style':
          style = {};
          if (bool) style['V14StyleTitle'] = true;
          style['V14Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    /**新增功能start */
    selectChange(e) {
      console.log('改变', e);
      // 判断是否使用静态数据
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      if (ChartsData?.currenEntry === 'staticData') {
        this.echartsClick = e;
        this.asyncLocalDatatest();
      } else {
        this.params = getFilterValue(e);
        this.startApiIntervalTask();
      }
    },

    echartClick(e) {
      e.stopPropagation();
      console.log('点击');
      let type = this.Configuration.propertyData.chartLink.value.linkType;
      let url = this.Configuration.propertyData.chartLink.value.linkUrl;
      jumpSomePlaceByLink(type, url);
      console.log('执行后');
    },
    getFilterValue(e) {
      return getFilterValue(e);
    },
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    async asyncLocalDatatest() {
      let refs = await this.LocalChartDataProcessing();
      let datestr = this.echartsClick;
      let LocalData = refs.data;
      let timeData = {
        staticData: LocalData[datestr],
      };
      this.handleChange(timeData);
    },
    setEchartsOptions(ParamData = null) {
      if (Object.keys(ParamData).length == 0 || ParamData.source.length == 0) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let echartsDataStyle = 'default';
      let unit = '';
      let dropDownNumberData = [];
      let lineBackgroundColor = { isShowRightOpen: true };
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      let dropDownData = []; // 下拉 数组 数据

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (this.Configuration.propertyData?.chartsDataStyle?.value) {
        echartsDataStyle = this.Configuration.propertyData.chartsDataStyle.value;
      }
      if (this.Configuration.propertyData?.chartsRightDragDisplayBar?.value) {
        lineBackgroundColor = this.Configuration.propertyData.chartsRightDragDisplayBar.value;
      }

      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;

        dropDownData = ParamData?.dropDownData; //ParamData里 下拉 数组 数据
        dropDownNumberData = ParamData?.dropDownNumberData;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.chartUnit?.value) {
        unit = this.Configuration.propertyData.chartUnit.value;
      }
      if (this.Configuration.propertyData?.chartsRightDropDown?.value) {
        this.value = this.Configuration.propertyData.chartsRightDropDown.value;
      }

      console.log(source);
      console.log(seriesList);
      console.log(chartColor);
      console.log(fontStyle);
      console.log(lineBackgroundColor, '35353534534534');

      let that = this;
      function dealSelectData() {
        let selectData = [];
        let yearData = [];
        let monthData = [];
        if (dropDownData) {
          // 遍历 dropDownData
          dropDownData.forEach(item_f => {
            let child = [];
            //
            if (item_f[3]) {
              item_f[3].forEach(item_c => {
                child.push({
                  label: item_c[0],
                  value: item_c[1],
                });
              });
            }
            if (item_f[2] != undefined && child.length == 0) {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
                modelValue: item_f[2],
              });
            } else if (item_f[2] == undefined && child.length == 0) {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
              });
            } else {
              selectData.push({
                label: item_f[0],
                value: item_f[1],
                modelValue: item_f[2],
                children: child,
              });
            }
          });
        }
        if (dropDownNumberData) {
          dropDownNumberData.forEach(Years => {
            let child = [];
            // 子 一月 二月... 判断
            if (Years[3]) {
              Years[3].forEach(item_D => {
                //  判断 是否有出现 展示第3个下拉框的标识
                if (item_D[2] != undefined && item_D[2] != null) {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                    // 需要出现 日 时
                    third: item_D[2],
                  });
                } else {
                  child.push({
                    label: item_D[0] + '月',
                    value: item_D[1],
                  });
                }
              });
            }
            // 父 不为空
            if (Years[0] != undefined && child.length != 0) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
                children: child,
              });
            } else if (Years[0] != undefined) {
              selectData.push({
                label: Years[0],
                value: Years[1],
                modelValue: Years[2],
              });
            }
          });
        }
        that.selectData = selectData;
      }
      if (this.value.isShowRightDropDownBox) {
        dealSelectData();
      }

      let xAixDataList = [];
      // let yAixDataList = [];
      let series = [];
      function DealData() {
        seriesList.forEach((s, index) => {
          let cate = {
            //这里放图表的数据
            name: s,
            type: 'line', //图表类型
            symbol: 'circle', //设定实心点
            symbolSize: 13, //设定实心点的大小
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 0.9,
                colorStops: [
                  {
                    offset: 0,
                    color: chartColor[index], // 0% 处的颜色
                  },
                  {
                    offset: 0.2,
                    color: chartColor[index].replace('1)', '0.5)'), // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: chartColor[index].replace('1)', '0)'), // 100% 处的颜色
                  },
                ],
                global: lineBackgroundColor.isShowRightOpen, // 缺省为 false
              },
            },
            itemStyle: {
              color: {
                type: 'radial',
                x: 0.5,
                y: 0.5,
                r: 0.4, // 中间圆心大小
                colorStops: [
                  {
                    offset: 0,
                    color: chartColor[index], // 中间圆心颜色
                  },
                  {
                    offset: 0.4,
                    color: chartColor[index], // 边框颜色
                  },
                  {
                    offset: 0.5,
                    color: 'rgba(240, 128, 19,0)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(240, 128, 19,0)',
                  },
                ],
              },
              borderColor: chartColor[index].replace('1)', '0.5)'), // 边框颜色
              borderWidth: 1, // 边框宽度
            },
            lineStyle: {
              normal: {
                color: chartColor[index],
              },
            },
            connectNulls: true,
            label: {
              show: true,
              position: 'top',
              color: '#fff',
            },
            data: [],
          };
          source.forEach(item => {
            xAixDataList.push(item.x);
            if (s === item.s) {
              cate.data.push(item.y);
            }
          });
          series.push(cate);
        });
        xAixDataList = [...new Set(xAixDataList)];
      }
      DealData();

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        tooltip: {
          trigger: 'axis',
          className: 'echarts-tooltip echarts-tooltip-dark',
          textStyle: {
            fontSize: this.$h_Ratio(15, this.$store),
            color: '#c8c8c8',
          },
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        legend: {
          show: !this.value.isShowRightDropDownBox,
          right: 10,
          top: 0,
          textStyle: {
            color: '#7d7c94',
            fontSize: this.$h_Ratio(14, this.$store),
          },
          itemWidth: 12,
          itemHeight: 10,
        },
        color: chartColor,
        grid: {
          //直角坐标系，图表的位置参数
          ...grid,
          containLabel: true, //grid 区域是否包含坐标轴的刻度标签。
          //这常用于『防止标签溢出』的场景，标签溢出指的是，标签长度动态变化时，可能会溢出容器或者覆盖其他组件。
        },
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              color: fontStyle.xAxisColor, //更改坐标轴文字颜色
              textStyle: {
                fontFamily: 'Microsoft YaHei',
              },
              fontSize: fontStyle.xAxisSize, //更改坐标轴文字大小
            },
            data: xAixDataList,
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: unit,
            nameTextStyle: {
              nameLocation: 'start',
              color: fontStyle.yAxisColor,
              fontSize: fontStyle.yAxisSize,
              padding: [0, 10, -6, 0], //间距分别是 上 右 下 左
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
              },
              interval: 0,
            },
            axisLabel: {
              color: fontStyle.yAxisColor, //更改坐标轴文字颜色
              fontSize: fontStyle.yAxisSize, //更改坐标轴文字大小
            },
          },
          {
            type: 'value',
            axisLine: {
              show: false,
              lineStyle: {
                color: fontStyle.yAxisColor,
              },
            },
          },
        ],
        series: series,
        animation: true,
      };
      // 关闭加载
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 本地下拉数据切换处理
    LocalChartDataProcessing() {
      return new Promise((resolve, reject) => {
        this.axios
          .get('/chartsData.json')
          .then(res => {
            this.DataProcessing = res;
            let data = this.$_.cloneDeep(res);
            // console.log(data, 'LocalChartDataProcessing');
            resolve(data);
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      clearInterval(this.apiIntervalTaskID);
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          // console.log(res, '请求切处理后的数据');
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setTimeout(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        // console.log('请求切处理后的数据', res);
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }

        console.log('header', header);
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          // console.log('[ this.params ] >', this.params);

          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   params: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          // let params = ChartsData.apiData.apiPostParams || '{}';
          // this.axios({
          //   method: ChartsData.apiData.apiUrlMethod,
          //   url: ChartsData.apiData.apiUrl,
          //   data: this.params,
          //   headers: header,
          // })
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            console.log(arryQuery, 'getApiDataRes res ------');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            console.log('getApiDataResByResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            console.log(arryQuery, 'getApiDataRes 11 res ------');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            console.log('getApiDataResByFilterAndResponseQuery');
            console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '基础拆线图',
    componentName: 'Line1Charts',
    componentOverViewImg: './img/charts/LineCharts/Line1Charts.png',
    id: '',
    style: {
      width: 300,
      height: 150,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
            // 可以使用data访问api请求的响应结果        
              let seriesList = []

              let seriesListKey = 'city'
              let seriesListChildrenKey = 'casts'

              data.forEach((item) => {
                seriesList.push(item[seriesListKey])
              })

              dataSet.seriesList = seriesList
              dataSet.source = []
              
              data.forEach((item) => {
                item[seriesListChildrenKey].forEach(item2 => {
                  dataSet.source.push({
                    s: item[seriesListKey],
                    x: item2.date,
                    y: item2.daytemp
                  })
                })
              })
            `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['杭州市', '太原市', '北京市'],
            source: [
              {
                s: '杭州市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '杭州市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '杭州市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '杭州市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },

              {
                s: '太原市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '太原市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '太原市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '太原市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },

              {
                s: '北京市',
                x: '2021-05-21',
                y: '25',
                i: 1,
              },
              {
                s: '北京市',
                x: '2021-05-22',
                y: '26',
                i: 2,
              },
              {
                s: '北京市',
                x: '2021-05-23',
                y: '20',
                i: 3,
              },
              {
                s: '北京市',
                x: '2021-05-24',
                y: '27',
                i: 4,
              },
            ],
          },
        },
      },
      // 链接
      chartLink: {
        propertyComponentName: 'ChartsLinkConfiger',
        value: {
          isOpenLink: false, // 是否开启链接
          linkType: 'inner', // 链接类型 inner内链场景、outer外链地址
          linkUrl: '', // 链接url ，inner时是场景的id、outer时是http地址
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 150,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '5%',
          top: '5%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartUnit: {
        propertyComponentName: 'MapChartUnit',
        value: '单位(张)',
      },
      chartsRightDropDown: {
        propertyComponentName: 'ChartsRightDropDownConfiger',
        value: {
          isShowRightDropDownBox: false,
        },
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
      chartsRightDragDisplayBar: {
        label: '是否开启图表背景色',
        propertyComponentName: 'DataDragDisplayBar',
        value: {
          isShowRightOpen: true,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Line1Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
  .DateDropDownSelect {
    position: absolute;
    top: 12px;
    right: 30px;
    z-index: 10;
  }
  .no-data {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #ccc;
  }
}
.V11Style {
  .DateDropDownSelect {
    right: 0 !important;
  }
  .DateDropDownSelect :deep().dis-block .drop-down-select:nth-child(1) .el-input__inner {
    width: 74px !important;
  }
  .DateDropDownSelect :deep().drop-down-select .el-input__inner {
    border: 1px solid #c63a36 !important;
    color: #fff !important;
  }
  .DateDropDownSelect :deep().el-icon-arrow-up:before {
    color: #fff !important;
  }
}
.link {
  // cursor:pointer;
  :deep()canvas {
    &:hover {
      // pointer-events: auto;
      cursor: pointer;
    }
  }
}
</style>
